import moment from "moment-timezone";

export default {
    name: 'monitorFilter',
    namespaced: true,
    state: {
        filtro: {
            show: false,
            integration_type: 'Automation',
            vns_filter: '',
            container_filter: '',
            company_filter: null,
            patient_filter: '',
            start_date: moment().subtract(7, 'days').startOf('day'),
            end_date: moment(),
            erro_filter: null,
        }
    },
    getters: {
        all (state) {
            return state.filtro
        },
        getSpecific (state, key) {
            return state.filtro[key]
        },
    },
    mutations: {
        setAll (state, obj) {
            state.filtro = obj
        },
        setSpecific (state, obj) {
            state.filtro = {...state.filtro, ...obj}
        },
    },
    actions: {
        setFiltro ({ commit, state }, obj) {
            commit('setAll', obj)
        },
        setSpecific ({ commit, state }, obj) {
            commit('setSpecific', obj)
        },
        reset ({ commit, state }) {
            commit('setSpecific', {
                show: false,
                integration_type: state.filtro.integration_type,
                start_date: moment().subtract(7, 'days').startOf('day'),
                end_date: moment(),
                vns_filter: '',
                container_filter: '',
                company_filter: null,
                patient_filter: '',
                erro_filter: null,
            })
        },
    }
}
